export const unitySendSceneName = (
  setSceneName: React.Dispatch<React.SetStateAction<string>>
) => {
  (window as { [key: string]: any })["send_scene_name"] = (value: any) => {
    console.log("send_scene_name", value);
    setSceneName(value);
  };
};
